import { FC, ReactNode } from 'react';

import { ReactComponent as InfoCircle } from 'assets/icons/infoCircle.svg';

import styles from './StaticNotification.module.scss';

interface StaticNotificationProps {
  text: string | ReactNode;
}

const StaticNotification: FC<StaticNotificationProps> = ({ text }) => {
  return (
    <div className={styles.successMessage}>
      <div className={styles.iconContainer}>
        <InfoCircle />
      </div>
      <div className={styles.textContainer}>
        <p>{text}</p>
      </div>
    </div>
  );
};

export default StaticNotification;
